import React from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";

const Courses = () => {
    return (
        <>
            <style>
                {`
            .countriesimg{
                background: #fff;
    box-shadow: 0px 2px 18px #eee;
    padding: 20px;
    border-radius: 25px;
    }
            `}
            </style>
            <BannerBreadcrumb head={"Popular Courses for Studying Abroad"} parades={"Discover the best STEM Master's programs abroad and choose the right path to shape your future with confidence."} pagename={"Courses"} />
            <div className="container mt-5 mb-5">
                <div className="row">
                    <h5 className="about-head text-center mb-4" style={{ color: "var(--primarycolor" }} >Best Courses to Study Abroad</h5>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Computer-Science.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Computer Science</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Mechanical-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Mechanical Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Electrical-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Electrical Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Civil-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Civil Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Biomedical-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Biomedical Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Environmental-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Environmental Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Master-in-Data-Science.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Data Science Management</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Bioengineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Bio Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-of-Engineering-Management.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Engineering Management</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Chemical-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Chemical Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Financial-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Financial Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Business-Analytics.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Business Analytics</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Aerospace-Engineering.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Aerospace Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-MIS.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">MIS Engineering</h6>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                        <img src="images/Masters-in-Materials-Science.jpg" alt="Courses" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Materials Science</h6>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Courses;